<template>
  <div class="index">
    <b-row style="margin-right: 0">
      <b-navbar class="nav-bg" style="padding-right: 0;height: 55px;" toggleable="xl" type="dark" variant="info">
        <div style="position: absolute;margin-left: 15px;font-size: 1.4rem;display: flex;align-items: center;">
          <img class="back" src="@/assets/images/back.png" alt="返回" @touchstart="back" @click="back">
          <img :src="$ftpUrl + logo" style="height: 30px;margin-right: 10px;margin-left: 17px;" v-if="logo">
                   <!-- <img v-else  :alt="projectName ? projectName : '华夏运通'" :src="require('@/assets/images/logo.png')"> -->
          <!--<span>{{ projectName }}</span>-->
        </div>
        <span class="title">{{ largeTitle  }}</span>
        <div style="width: 99%;bottom: 0;position: absolute;">
          <div
            style="width: 250px;height: 2px;margin:auto;background-image: linear-gradient(to right, rgba(255, 255, 255, .1), rgba(255, 255, 255, .8), rgba(255, 255, 255, .1));">
          </div>
        </div>
        <b-navbar-brand href="#"></b-navbar-brand>
        <!--这个是缩小后右上角的切换图标-->
        <b-navbar-toggle target="nav-collapse" style="position:absolute;right: 20px;"
                         v-if="url.indexOf('#/platen') === -1"></b-navbar-toggle>
        <!--这个是子系统信息和物联平台信息-->
        <b-collapse id="nav-collapse" is-nav v-if="!url.includes('#/platen') && !url.includes('#/floor/floor-navigation') && !url.includes('#/electricity') && !url.includes('#/group-control') && !url.includes('#/ptms-cabinet')">
          <b-navbar-nav style="position:absolute;right: 15px;">
            <!-- 打开桌面应用 -->
            <!-- <b-nav-item @click="openTv">
            <b-icon b-icon icon="tv"></b-icon>
            </b-nav-item> -->
            <div :key="index" v-for="(item,index) in menus" v-show="url.indexOf('/overview-setting') === -1">
              <b-nav-item
                v-if="item.navUrl !== 'energyUrl' && item.navUrl !== 'assetUrl' && item.navUrl !== 'tickUrl' && item.navUrl !== 'device-manager' && item.navUrl !== 'ptms-cabinet' && item.navUrl !== 'electricity' && item.navUrl !== 'group-control'"
                :key="item.id"
                :href="item.navUrl === 'platen' ? platenUrl : '' "
                :target="item.parameters === '_blank' ? '_blank' : '_self' "
                :class="[item.navUrl === 'platen' ? 'titleLine-right' :'',item.parameters === '_blank' || item.parameters === 'native' ? 'titleLine' : '']">
                <!--              跳转新页面-->
                <router-link v-if="item.parameters === 'native'"
                             :to="item.navUrl" style="color: rgba(7, 230, 248, 1);"
                          @touchstart.native="newPage(item.navUrl,true)"   @click.native="newPage(item.navUrl,true)" tag="a" target="_blank">
                  <img v-if="item.imgOut" :src="item.imgOut">
                  {{ item.cnName }}
                </router-link>
                <!--              跳转新地址-->
                <span v-else-if="item.parameters === '_blank'">
                {{ item.cnName }}
              </span>
                <router-link v-else :to="item.navUrl" tag="div">
                  <el-badge v-if="item.navUrl === 'realTime-alarm'" :is-dot="hasAlarm">{{ item.cnName }}</el-badge>
                  <span v-else>{{ item.cnName }}</span>
                </router-link>
              </b-nav-item>
            </div>
            <!--          系统切换-->
            <b-nav-item-dropdown class="navbar-transparent" id="more" right v-if="systemSwitching || linkage"
                                 v-show="url.indexOf('/overview-setting') === -1">
              <template #button-content>
                <img style="margin-top: 5px; "
                     :src="require('@/assets/images/index/more.png')"
                     class="mr-3 d-inline-block align-top bg-transparent" size="sm">
              </template>
              <!--子系统-->
              <div v-for="(item) in linkage" :key="item.clientId">
                <b-nav-item
                  v-if="item.autoApprove === 'true'"
                  :key="item.clientId"
                  :href="item.website"
                  :target="item.autoApprove === 'true' ? '_blank' : ''"
                  :class="item.autoApprove === 'true' ? 'titleLine' : ''">
                  <!--              跳转新地址-->
                  <span v-if="item.autoApprove === 'true'">
                    {{ item.appName }}
                  </span>
                </b-nav-item>
              </div>
              <div v-for="(item,index) in systemSwitchingData" :key="index">
                <b-nav-item
                  v-if="item.navUrl === 'device-manager' || item.navUrl === 'ptms-cabinet' || item.navUrl === 'electricity' || item.navUrl === 'group-control'"
                  :key="item.id"
                  :href="item.navUrl === 'device-manager' ? IOTPlatformUrl : item.navUrl === 'ptms-cabinet' ? ptmsCabinetUrl : item.navUrl === 'electricity' ? electricityUrl : groupControlUrl"
                  :target="item.parameters === '_blank' ? '_blank' : '_self' "
                  :class="[item.parameters === '_blank'  ? 'titleLine' : '']">
                  <!--              跳转新页面-->
                  <router-link v-if="item.parameters === 'native'"
                               :to="item.navUrl" style="color: rgba(7, 230, 248, 1);"
                           @touchstart.native="newPage(item.navUrl,true)"    @click.native="newPage(item.navUrl,true)" tag="a" target="_blank">
                    <img v-if="item.imgOut" :src="item.imgOut">
                    {{ item.cnName }}
                  </router-link>
                  <router-link v-else :to="item.navUrl" tag="div">
                    <el-badge v-if="item.navUrl === 'realTime-alarm'" :is-dot="hasAlarm">{{ item.cnName }}</el-badge>
                    <span v-else>{{ item.cnName }}</span>
                  </router-link>
                </b-nav-item>
              </div>

            </b-nav-item-dropdown>
            <!--        声音开关-->
            <b-navbar-nav class="mt-auto mb-auto pointer"
                          v-show="url.indexOf('/overview-setting') === -1">
              <div  @touchstart="switchLanguageBroadcast" @click="switchLanguageBroadcast" style="margin-top: 10px; margin-bottom: 10px;">
                <img
                  :src=" voice === 'true' ?  require('@/assets/images/overall_situation/0.png') : require('@/assets/images/overall_situation/1.png')"
                  class="mr-3 d-inline-block align-top bg-transparent" size="sm">
              </div>
            </b-navbar-nav>

            <b-nav-item-dropdown class="navbar-transparent" right style="margin-left: 15px;" text="Lang">
              <template #button-content>
                <b-avatar
                  :src="account.avatar ? $ftpUrl + account.avatar : require('@/assets/images/default/user_avatar_default.png')"
                  class="mr-1 d-inline-block align-top bg-transparent" size="sm"></b-avatar>
                <strong>{{ accountName }}</strong>
                <b-icon aria-hidden="true" class="ml-1" icon="gear-fill"></b-icon>
              </template>
              <b-dropdown-item> [ {{ account.code }} ]</b-dropdown-item>
              <b-dropdown-item @touchstart="newPage(iamUrl,false)" @click="newPage(iamUrl,false)">个人资料</b-dropdown-item>
              <b-dropdown-item @touchstart="logout" @click="logout" href="#">退出登录</b-dropdown-item>
            </b-nav-item-dropdown>
          </b-navbar-nav>
        </b-collapse>

      </b-navbar>
    </b-row>
    <router-view></router-view>
    <!--    修改密码-->
    <change-password :text="text" :showClose="false" :dialogVisible="changePassordVisible"
                     @closeChangePassword="closeChangePassword"></change-password>
    <span v-if="url.indexOf('#/platen') !== -1 && leftMenuFlag!==true"
          style="display: flex;align-items: center;justify-content: flex-end; height: 131%">
         <div id="mouse" @mouseover="mouseOver" @mouseleave="mouseLeave" style="margin-bottom:18%">
           <transition name="fade">
            <img v-if="isExitHover" title="3D平台" :width="25"
                 src="../assets/images/basic_operations/menu/收缩.png">
          <div v-else style="position: relative">
            <img type="button" :width="40"
                 src="../assets/images/basic_operations/menu/悬框.png">
            <div style="position: absolute;top: 12%">
               <a :href="threeDUrl" target="_blank">
                          <img :width="40"
                               src="../assets/images/basic_operations/menu/3D.png">
               </a>
              <router-link :to="{path:'/overview'}" target="_blank">
                          <img title="进入系统" :width="40"
                               src="../assets/images/basic_operations/menu/进系统.png"
                               style="margin-bottom:80%;margin-top: 66%">
              </router-link>
              <router-link :to="{path:'/platen-setting'}" target="_blank">
                          <img title="大屏配置" :width="40"
                               src="../assets/images/basic_operations/menu/大屏.png">
              </router-link>
            </div>
          </div>
           </transition>
        </div>
    </span>
    <!--  左侧菜单-->
    <span v-else
          style="display: flex;align-items: center;justify-content: flex-start; height: 98%;width: 100%;z-index: 9999;"
          :style="leftMenuClick?'position: relative;':''"
          :class="leftMenuClick?'leftMenuDialog':''">
      <div style="cursor: pointer" v-show="url.indexOf('#/platen') !== -1 && !leftMenuClick" @click="changeLeftMenuStatus">
        <el-image style="width: 25px;height: 56px" :src="leftMenuImage"/>
      </div>
      <div style="cursor: pointer;position: relative" v-show="(url.indexOf('#/platen') !== -1 && leftMenuClick) || url.indexOf('#/floor/floor-navigation') !== -1" @click="changeLeftMenuStatus">
        <el-image style="width: 25px;height: 56px" :src="leftMenuClickImage"/>
        <div style="position: absolute;left: 40px;top: -100px;">
          <div class="leftMenuListBg" @touchstart="pushRouter('/overview')"  @click="pushRouter('/overview')">综合态势</div>
          <div class="leftMenuListBg" @touchstart="pushRouter('/realTime-alarm')" @click="pushRouter('/realTime-alarm')">告警中心</div>
          <div class="leftMenuListBg" @touchstart="pushRouter('/device-list')" @click="pushRouter('/device-list')">设备一览</div>
          <!-- <div class="leftMenuListBg" @click="newPage(EnergySystemUrl+'/#/energyStatistic',false)">
            报表统计
          </div> -->
         <div class="leftMenuListBg" @touchstart="pushRouter('/historical/device-history')" @click="pushRouter('/historical/device-history')">
            报表统计
          </div>
          <!-- <div class="leftMenuListBg" @touchstart="pushRouter('/floor/floor-navigation')" @click="pushRouter('/floor/floor-navigation')">楼层导航</div> -->

          <div class="leftMenuListBg" @touchstart="pushRouter('/platen-setting')" @click="pushRouter('/platen-setting')"
               style="color: #299BFF;width: 138px;height: 41px;text-align: center;margin-top: 30px">
            <el-image style="width: 15px;height: 15px;margin-right: 6px" :src="settingImage"/>
            <span>大屏配置</span>
          </div>
        </div>
      </div>
    </span>
  </div>
</template>

<script>
import 'element-ui/lib/theme-chalk/display.css';
import {getSystematicByCodes, getSystematicByParent} from "@/network/systematic";
import {alarmRealTimeTotal, getAlarmByCommitTimeAsc} from "@/network/alarm-realtime";
import {getResourceList} from "@/network/resource";
import {getAccountInfo} from "@/network/account";
import {logout, redirectLogin} from "@/network/sso";
import {cancel, getCookie, playRead, setCookie} from "@/utils/common";
import {getCurrentCustomPage} from "@/network/device-custom-page";
import ChangePassword from "@/components/component/ChangePassword";

export default {
  name: "Index",
  components: {ChangePassword},
  created() {
    this.getAccountInfo()
    this.getByCodes();
    this.getLinkage();
    this.voice = getCookie("audioAlarm");
    this.$store.dispatch('addIntervalObj', {'getRealtimeAlarm:2000': this.getAlarmInfo})

  },
  destroyed() {
    this.$store.dispatch('removeIntervalObj', 'getRealtimeAlarm')
  },
  data() {
    return {
      changePassordVisible: false,
      text: '',
      menus: [],
      largeTitle: '',
      projectName: '',
      logo: null,
      iamUrl: window.g.iamUrl + '?index=personal/index',
      hasAlarm: false,
      codes: ['platform_abbreviation', 'platform_full_name', 'PC_terminal_logo', 'capacity_system', 'assets_system', 'tick_system'],
      platenUrl: '#/platen',
      IOTPlatformUrl: '#/device-manager/device-space',
      electricityUrl: '#/electricity',
      groupControlUrl: '#/group-control',
      ptmsCabinetUrl: '#/ptms-cabinet',
      account: {},
      accountDetail: {},
      accountName: '',
      showEnergy: 'false',
      assetsSystem: 'false',
      tickSystem: 'false',
      voice: 'true',
      url: window.location.hash,
      systemSwitching: true,
      systemSwitchingData: [],
      isExitHover: true,
      threeDUrl: window.g.threeDUrl,
      // 左侧菜单是否显示
      leftMenuFlag: window.g.leftMenu,
      leftMenuClick: false,
      leftMenuImage: require('@/assets/images/compont/menuLeft.png'),
      leftMenuClickImage: require('@/assets/images/compont/leftMenuClick.png'),
      settingImage: require('@/assets/images/icon/设置.png'),
      EnergySystemUrl:'',
      linkage:[]
    };
  },
  watch: {
    voice() {
      this.voice = getCookie("audioAlarm")
    },
    // 监听路由
    $route: {
      handler(val) {
        this.url = window.location.hash;
        this.largeTitle = val.name
        if (val.path !== '/group-control' && val.path !== '/electricity' && val.path !== '/ptms-cabinet') {
          this.getByCodes();
        }
      },
    }
  },
  methods: {
    back() {
      this.$router.go(-1);
    },
    getResourceList() {
      // 初始化菜单
      getResourceList().then(res => {
        if (res.code === 0) {
          console.log("菜单参数：", res.data);
          let menus = res.data.resources.filter(item => item.superId === '0')
          this.menus = menus;
          console.log(this.url, 'url')
          var data = [];
          var systemSwitchingTrue = false;
          for( var i = 0; i < menus.length; i++ ) {
            if (menus[i].navUrl === 'assetUrl' || menus[i].navUrl === 'device-manager' || menus[i].navUrl === 'electricity' || menus[i].navUrl === 'group-control' || menus[i].navUrl === 'ptms-cabinet') {
              data.push(menus[i]);
              systemSwitchingTrue = true;
            }
          }
          this.systemSwitching = systemSwitchingTrue;
          this.systemSwitchingData = data;
          console.log("跳转平台：", this.systemSwitchingData);
        }
      })
    },
    mouseOver() {
      this.isExitHover = false
    },
    //获取子系统地址
    getLinkage() {
      //let codes = ["linkage"];
      getSystematicByParent().then(res => {
        this.linkage = res.data;
        console.log("子系统信息", this.linkage)
        // 中科院，赋值给能效系统报表数据
        this.linkage.forEach(item=>{
          if(item.appNameEn==="Energy System"){
            this.EnergySystemUrl=item.website
          }
        })
      })
    },
    mouseLeave() {
      this.isExitHover = true
    },
    newPage(pageUrl, newUrl) {
      if (newUrl) {
        // let routeUrl = this.$router.resolve({
        //   path: pageUrl
        // });
        // window.open(routeUrl.href, '_blank')
        this.$router.push(pageUrl)
      } else {
        window.open(pageUrl, '_blank');
      }
    //  this.$router.push(pageUrl)
    },
    getByCodes() {
      let platen = false
      if (this.url.indexOf('#/platen') === 0) {
        this.getCurrentCustomPage()
        platen = true
      }
      getSystematicByCodes(this.codes).then(res => {
        if (res.code === 0) {
          res.data.forEach(item => {
            if (!platen && item.code === "platform_abbreviation" && this.url.indexOf('#/platen') !== 0) {
              this.projectName = item.val1;
            }
            if (!platen && item.code === "platform_full_name") {
              this.largeTitle = item.val1;
            }
            if (item.code === "PC_terminal_logo") {
              this.logo = item.icon1;
            }
            if (item.code === "capacity_system") {
              this.showEnergy = item.val1;
            }
            if (item.code === "assets_system") {
              this.assetsSystem = item.val1;
            }
            if (item.code === "tick_system") {
              this.tickSystem = item.val1;
            }
          })
        }
        this.getResourceList()
      })
    },

    //读取大屏参数
    getCurrentCustomPage() {
      getCurrentCustomPage().then(res => {
        if (res.code === 0) {
          console.log(res.data);
          this.projectName = res.data.abbreviation
          this.largeTitle = res.data.title
        }
        console.log(this.projectName, "---");
      })
    },

    //语音播报开关
    switchLanguageBroadcast() {
      getSystematicByCodes(["voiceWarningNotification"]).then(res => {
        if (res.code === 0) {
          if (res.data[0].code === "voiceWarningNotification" && res.data[0].val1 === 'true') {
            if (this.voice === 'true') { //停止
              setCookie("audioAlarm", false, null);
              cancel();
              this.voice = 'false';
              this.$message({
                message: "声音播报已关闭",
                type: 'info'
              });
            } else { //开启
              this.voice = 'true';
              setCookie("audioAlarm", true, null);
              // 立即显示开启提示
              this.$message({
                message: "正在开启声音播报...",
                type: 'info',
                duration: 1500
              });
              // 先清除可能存在的旧语音，然后延迟一下再播放新的
              cancel();
              setTimeout(() => {
                // 传入已获取的配置，避免重复请求
                this.startVoice(res.data[0]);
              }, 200);
            }
          } else {
            this.$message({
              message: "请先开启声音通知配置",
              type: 'warning'
            });
          }
        }
      })
    },

    //开启语音（config参数可选，如果传入则直接使用，不传则会重新请求）
    startVoice(config = null) {
      // 重置语音播放状态，并标记用户已交互（点击开启按钮本身就是交互）
      if (window.app) {
        window.app.isVoicePlaying = false;
        window.app.hasUserInteracted = true; // 用户主动开启声音，标记已交互
      }
      
      // 刷新当前路由页面的数据（如果是实时告警页面）
      if (this.$route.path === '/realTime-alarm') {
        // 通知实时告警页面刷新数据
        this.$root.$emit('refreshAlarmData');
      }
      
      // 如果传入了配置，直接使用，避免重复请求
      if (config && config.code === "voiceWarningNotification" && config.val1 === 'true') {
        getAlarmByCommitTimeAsc().then(alarm => {
          if (alarm.data != null && alarm.data.length > 0) {
            setCookie("audioAlarm", true, null);
            this.$message({
              message: "声音播报已开启，正在播放" + alarm.data.length + "条告警",
              type: 'success'
            });
            for (var i = 0; i < alarm.data.length; i++) {
              playRead(alarm.data[i].msg);
            }
          } else {
            this.$message({
              message: "声音播报已开启，当前暂无告警",
              type: 'info'
            });
          }
        })
      } else {
        // 没有传入配置，则重新请求配置（保持向后兼容）
        getAlarmByCommitTimeAsc().then(alarm => {
          if (alarm.data != null && alarm.data.length > 0) {
            //语音播报
            getSystematicByCodes(["voiceWarningNotification"]).then(res => {
              if (res.code === 0) {
                if (res.data[0].code === "voiceWarningNotification") {
                  setCookie("audioAlarm", true, null);
                  if (res.data[0].val1) {
                    this.$message({
                      message: "声音播报已开启，正在播放" + alarm.data.length + "条告警",
                      type: 'success'
                    });
                    for (var i = 0; i < alarm.data.length; i++) {
                      playRead(alarm.data[i].msg);
                    }
                  }
                }
              }
            })
          } else {
            this.$message({
              message: "声音播报已开启，当前暂无告警",
              type: 'info'
            });
          }
        })
      }
    },

    getAlarmInfo() {
      alarmRealTimeTotal().then(res => {
        if (res.code === 0) {
          if (res.data.gateway + res.data.point > 0) {
            this.hasAlarm = true;
          } else {
            this.hasAlarm = false;
          }
        }
      })
    },
    getAccountInfo() {
      getAccountInfo().then(res => {
        this.account = res.data.account
        if (!this.account.loginTime) {
          this.changePassordVisible = true;
          this.text = "您是首次登陆，请修改密码";
        }
        this.accountDetail = res.data.accountDetail
        if (this.account.nickname) {
          this.accountName = this.account.nickname
        } else if (this.accountDetail.name) {
          this.accountName = this.accountDetail.name
        } else {
          this.accountName = this.account.code
        }
      })
    },
    // 关闭修改密码弹窗
    closeChangePassword() {
      this.changePassordVisible = false;
    },
    //退出登录
    logout() {
      logout().then(res => {
        console.log(res)
      })
      redirectLogin()
    },
    // 改变左侧展开状态
    changeLeftMenuStatus() {
      this.leftMenuClick = !this.leftMenuClick
    },
    // 路由跳转
    // toRouter(router) {
    //   let routeUrl = this.$router.resolve({
    //     path: router
    //   });
    //   // this.url = routeUrl.href;
    //   window.open(routeUrl.href, '_blank')
    // },
    pushRouter(path) {
      this.$router.push(path)
    }
    // 打开桌面应用
    // openTv() {
    //       // 要打开的 URL Scheme
    //   const urlScheme = 'openTest';
  
    //   // 打开相关的客户端程序
    //   window.open(urlScheme + ':', '_blank');
    // }
  }
}
</script>

<style>
.index {
  height: 100vh;
  background-image: url('../../public/static/background1.png') !important;
}

#more .dropdown-toggle::after {
  visibility: hidden;
}
.back {
  width: 36px;
  height: 36px;
  cursor: pointer;
}
#more .titleLine {
  /*border-left: 1px solid rgba(41, 155, 255, .2);*/
  margin-left: 5px;
  padding-left: 5px;
}

.bg-info {
  background-color: transparent !important;
}

.nav-bg {
  width: 100%;
  background-image: linear-gradient(to right, rgba(4, 22, 38, .3), rgba(73, 164, 243, .3), rgba(4, 22, 38, .3));
}

.index .title {
  font-weight: normal;
  font-size: 1.8rem;
  width: 100%;
  text-align: center;
}

.index .el-progress-circle__track {
  stroke: rgba(48, 141, 233, .3);
}

@media (min-width: 1200px) {
  .titleLine {
    /*border-left: 1px solid rgba(41, 155, 255, .2);*/
    margin-left: 5px;
    padding-left: 5px;
  }
}

@media (min-width: 1200px) {
  .titleLine-right {
    border-right: 2px solid rgba(41, 155, 255, .2);
    margin-right: 5px;
    padding-right: 5px;
  }
}

.fade-enter {
  opacity: 0;
}

.fade-enter-active {
  transition: opacity 2s;
}

.fade-leave {
  opacity: 0;
}

.fade-leave-active {
  transition: opacity 0s;
}
</style>
<style scoped>

.energy:hover {
  text-decoration: underline;
}

.leftMenuDialog {
  background-color: black;
  opacity: 0.9;
}

.leftMenuListBg {
  background-image: url("../assets/images/compont/leftMenuListDiv.png");
  background-size: 138px 41px;
  width: 138px;
  height: 41px;
  text-align: center;
  line-height: 41px;
  margin-bottom: 12px;
}
</style>
